import { render } from "./RegisterSuccessForm.vue?vue&type=template&id=1c9819d4&ts=true"
import script from "./RegisterSuccessForm.vue?vue&type=script&lang=ts"
export * from "./RegisterSuccessForm.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/sylvainleris/Documents/workspace/ADETEC/AdConnect/fr.adetec.adconnect.www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__